import { useContext } from 'react';
import { RolesContext } from 'contexts/roles_context';

const useRoles = () => {
    return useContext(RolesContext);
};

export default useRoles;
